import { Navbar1 } from "components/navbars";
import { Footer1 } from "components/footer";
import Seo from "components/Seo";
import BackToTop from "components/BackToTop";

import Career from "crm/other/Career";
import PrivacPolicy from "crm/other/Privacy Policy";

export default function Privacy() {
    return (
        <>
            {/* <Seo pageName="features" /> */}

            {/* <Navbar1 /> */}
            <PrivacPolicy />
            <Footer1 />
            <BackToTop />
        </>
    );
}
